const hairhub = {
  text: `
    <p>Our Jam Jam café is open daily and offers a selection of delicious wholesome food, freshly baked goods and a great variety of beverages. Catch up with friends or work while your children play or simply enjoy a lunch bite in our cozy café.</p>
    `,
  image: 'assets/images/banners/banner-cafe.jpg',
};

export default hairhub;
